
/* injects from baggage-loader */

'use strict';

import AccountSettingsConnectedAccountsComponent from './account.settings.connected-accounts.component';

const AccountSettingsConnectedAccountsPageModule = angular.module('account-settings-connected-accounts-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.settings.connected-accounts', {
        url: '/connected-accounts?code&state',
        // Requires valid login to view
        protected: true,
        component: 'accountSettingsConnectedAccounts',
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          integrations: function(User, AccountIntegrationSchema) {
            let query = User.getCurrent().relation('integrations').query();
            return query.find();
          }
        }
      });
  })
  .component('accountSettingsConnectedAccounts', new AccountSettingsConnectedAccountsComponent());

export default AccountSettingsConnectedAccountsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/connected-accounts/account.settings.connected-accounts.module.js